import { ApiProperty } from "@nestjs/swagger";
import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, OneToMany } from "typeorm";
import { PickUp } from "../../pickup/pickup.entity";

@Entity('route')
export class Route {

    @PrimaryGeneratedColumn("increment",{name:'route_id'})
    routeId:number;

    @Column("varchar",{
        nullable:false,
        length:50,
        name:"route_number"
        })
      routeNumber:string;

    @Column("varchar",{
        nullable:false,
        length:50,
        name:"vehicle_number"
        })
      vehicleNumber:string;

      @Column("varchar",{
        nullable:false,
        length:50,
        name:"distance"
        })
      distance:string;

      @Column("varchar",{
        nullable:false,
        length:50,
        name:"plant"
        })
      plant:string;

      @Column("varchar",{
        nullable:false,
        length:50,
        name:"pick_up"
        })
      pickUp:string[];

      @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;
    
      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
          nullable: false,
          name: "created_user",
          length:50
      })
      createdUser: string | null;
    
    
      @UpdateDateColumn({
          name: "updated_at",
          type:'datetime'
      })
      updatedAt: Date;
    
      @Column("varchar", {
          nullable: true,
          name: "updated_user",
          length:50
      })
      updatedUser: string | null;
    
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;

      // @ApiProperty({type: [PickUp]})
      // @OneToMany( type=> PickUp, info => info.route, {cascade: true})
      // pickUpPoints: PickUp[];
    
}